import React from 'react'
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import { Tab, Menu, Label, Container, Header } from 'semantic-ui-react';
import _ from 'lodash';
import { toastr } from 'react-redux-toastr';

import PlatformUserListJson from './PlatformUserListJson';
import InvitationUserListJson from './InvitationListJson';
import CommonTable from '../../../drive/Table/TableLayout'



var moment = require('moment');
class UsersData extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tableHeader: PlatformUserListJson,
            inviteUserModalFlag: false,
            activeIndex: 0,
            _limit: 10,
            _sort: "createdAt"
        };
        this.handleDropDownItem = this.handleDropDownItem.bind(this);
    }

    onQueryChange = (query) => {
        let payload = {
            query: query
        }
        dispatch.platform.getAllPlatformUsers(payload)
    };

    addColumn = (newColumns) => {
        if (newColumns) {
            this.setState({ tableHeader: newColumns })
        }
    };

    handleDropDownItem = (event, type, data) => {

        if (type.text === "Resend") {
            this.resendInvitation(event, data)
        }
        if (type.text === "Delete") {
            this.deleteInvitaion(event, data)
        }
    }

    setInviteUserModal = (open) => {
        this.setState({ inviteUserModalFlag: open })
    }

    gotoInviteUser = (e) => {
        this.setInviteUserModal(true)
    }
    componentWillMount = async () => {
        let payload = {
            query: {}
        }
        await dispatch.platform.getAllPlatformUsers(payload)
        await dispatch.platform.getAllPlatformUsersCount();
        await dispatch.account.getInviteByAccountIdAsync(this.props.selectedAccount._id)

        if (this.props.match.params.tab) {
            this.localSetState(this.props.match.params.tab)
        } else {
            this.localSetState(0)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.params.tab && this.props.platformUsers.total !== nextProps.platformUsers.total) {
            this.localSetState(this.props.match.params.tab)
        }
    }

    handleTabChange = (e, data) => {
        this.setState({ activeIndex: data.activeIndex });
        this.localSetState(data.activeIndex)
    }

    localSetState = async (activeIndex) => {
        this.setState({ activeIndex: activeIndex })
        if (Number(activeIndex) === 0) {
            this.setState({
                listData: this.props.platformUsers.data,
                tableHeader: PlatformUserListJson,
                _sort: 'firstName'
            })
        } else if (Number(activeIndex) === 1) {
            this.getInvitationData()
        }
    }

    getInvitationData = async () => {
        await dispatch.account.getInviteByAccountIdAsync(this.props.selectedAccount._id)
        if (this.props.accountInvitedUser && this.props.accountInvitedUser.length !== 0) {
            for (let i = 0; i < this.props.accountInvitedUser.length; i++) {
                let expiryTime = moment.duration(moment().diff(moment(this.props.accountInvitedUser[i].createdAt))).asHours() < 24;
                this.props.accountInvitedUser[i].referenceName = this.props.accountInvitedUser[i].referenceId.name;
                this.props.accountInvitedUser[i].isActive = expiryTime;
            }
        }
        this.setState({
            listData: this.props.accountInvitedUser,
            tableHeader: InvitationUserListJson,
            _sort: 'createdAt'
        })
    }

    resendInvitation(event, invite) {
        let message = <div className="confirmMessage">
            <h3>Resend Invitation</h3>
            <label>{invite.email}</label>
            <p>Are you sure that you wish to resend this invitation?</p>
        </div>
        toastr.confirm(message, {
            onOk: async () => {
                let organizationObj = {
                    "name": invite.referenceId.name
                }
                let emailObject = {
                    templateName: "resendInviteMail",
                    toEmail: invite.email,
                    invite: invite,
                    invitationCode: invite._id,
                    fromUser: this.props.user,
                    organization: organizationObj,
                    subject: `You have been Invited to join the "${invite.referenceId.name}" account on Aspenify platform.`
                }
                await dispatch.invite.resendInvitation(emailObject);
                this.getInvitationData()
            }
        });
    }

    async deleteInvitaion(event, invite) {
        let message = <div className="confirmMessage">
            <h3>Delete Invitation</h3>
            <label>{invite.firstName} {invite.lastName}</label>
            <p>Are you sure that you wish to delete this invitation?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: async () => {
                await dispatch.invite.deleteInvitaionAsync(invite);
                this.getInvitationData()
            }
        });
    }

    render() {

        const { activeIndex, tableHeader } = this.state;

        let table = <CommonTable
            //tableName="Platform Users"
            tableHeader={tableHeader}
            listData={this.state.listData}
            searchable={false}
            totalCount={this.state.listData && this.state.listData.length}
            loading={this.state.loading}
            //onQueryChange={this.onQueryChange}
            limit={this.state._limit}
            sort={this.state._sort}
            addColumn={this.addColumn}
            handleDropDownItem={this.handleDropDownItem}
            totalCountWithoutSearch={this.props.platformUsersCount && this.props.platformUsersCount.total}
            activeIndex={activeIndex}
        />


        const panes = [
            {
                menuItem: <Menu.Item key='Owners'>
                    Platform Admin <Label>{this.props.platformUsers.total}</Label>
                </Menu.Item>, render: () => table
            }, {
                menuItem: <Menu.Item key='Invitations' disabled={!this.props.accountInvitedUser}>
                    Invitations{this.props.accountInvitedUser ? <Label>{this.props.accountInvitedUser.length}</Label> : ''}
                </Menu.Item>, render: () => table
            },
        ]

        return (

            <Container fluid className="pad_20 listingUsers two-block">
                <div className="listHeader">
                    <Header as='h4' floated='left'>
                        Platform Users
                            <Label size="small" >
                            {this.props.platformUsers.total
                            }</Label>
                    </Header>
                    <div className="float-right"></div>
                </div>
                <div className="listTab">
                    <Tab
                        style={{ padding: 0 }}
                        menu={{ secondary: true, pointing: true }}
                        panes={panes}
                        activeIndex={activeIndex}
                        onTabChange={this.handleTabChange}
                        className="two-block" />
                </div>
            </Container>



        )
    }
}

export default withRouter(UsersData);